import { useState, useEffect, useCallback } from 'react';
import { usePppApi } from '../services/pppApi';

// `api` opzionale: di default usa l'api PPP (ruoli interni). L'area operatore
// passa la propria api (useNotificheOperatoreApi) per puntare a /v1/operatore.
export function useNotifiche(params = {}, apiOverride = null) {
  const pppApi = usePppApi();
  const api = apiOverride ?? pppApi;
  const [notifiche, setNotifiche] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(() => {
    setLoading(true);
    api.listNotifiche(params, {
      onSuccess: (data) => {
        setNotifiche(data.data ?? []);
        setPagination({
          currentPage: data.current_page,
          lastPage:    data.last_page,
          total:       data.total,
          perPage:     data.per_page,
        });
        setLoading(false);
      },
      onFormError: (err) => { setError(err); setLoading(false); },
    });
  }, [params.nonLette, params.perPage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetch(); }, [fetch]);

  return { notifiche, pagination, loading, error, refresh: fetch };
}

export function useContaNotifiche(apiOverride = null) {
  const pppApi = usePppApi();
  const api = apiOverride ?? pppApi;
  const [count, setCount] = useState(0);

  const fetch = useCallback(() => {
    api.contaNotifiche({
      onSuccess: (data) => setCount(data.count ?? 0),
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetch();
    const interval = setInterval(fetch, 60000);
    return () => clearInterval(interval);
  }, [fetch]);

  return { count, refresh: fetch };
}
